/**
 * @file Mobile Nav.
 */

import { gsap } from 'gsap';

/**
 * Mobile Nav component.
 */
const vMobileNav = () => {
	const mobileNav = document.querySelector('.v-mobile-nav');

	if (!mobileNav) {
		return;
	}

	const body = document.querySelector('body');
	const query = window.matchMedia('(min-width: 1024px)');
	const nav = mobileNav.querySelector('.v-mobile-nav__nav');
	let isAnimating = false;
	const tl = gsap
		.timeline({
			paused: true,
			onStart: () => {
				isAnimating = true;

				if (!tl?.reversed()) {
					body.classList.toggle('menu-open', true);
				}
			},
			onReverseComplete: () => {
				isAnimating = false;
				body.classList.toggle('menu-open', false);
			},
			onComplete: () => {
				isAnimating = false;
			},
		})
		.from(mobileNav, {
			xPercent: 100,
		})
		.from(nav, {
			opacity: 0,
		});

	/**
	 * Toggle the menu state.
	 * @param {boolean} open  - Whether the menu should be open or closed.
	 */
	const toggleMenu = (open = true) => {
		if (query.matches || isAnimating) {
			return;
		}

		// open the menu
		if (open) {
			tl.timeScale(1).play();
		} else {
			tl.timeScale(-1.5).reverse();
		}
	};

	document.addEventListener('vNavTrigger', ({ detail }) => {
		toggleMenu(detail.isOpen);
	});
};

export default vMobileNav;
